export const chatKeys = {
  all: ['chats'] as const,
  list: () => [...chatKeys.all, 'list'] as const,
  detail: (id: MaybeRef<number>) => [...chatKeys.all, 'detail', id] as const,
};

export const chatMessagKeys = {
  all: ['chat-messages'] as const,
  list: (chatId: MaybeRef<number>) =>
    [...chatMessagKeys.all, 'list', chatId] as const,
};
